import { app } from '../../../app';

class DirectoriesResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getCompanyDirectories(companyId) {
        const url = `app/rest/v2/company/${companyId}/directories`;
        return this.$http.get(url).then(({data}) => data);
    }

    createDirectory(companyId, name, type) {
        const url = `app/rest/v2/company/${companyId}/directories`;
        const params = {name, type};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getSaaspassCloudDirectoryGroups(companyId) {
        const url = `app/rest/v2/company/${companyId}/directories/spcloud/groups`;
        return this.$http.get(url).then(({data}) => data);
    }

    getDirectory(companyId, directoryId, type) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {type};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    updateDirectory(companyId, directory) {
        const url = `app/rest/v2/company/${companyId}/directories/${directory.id}`;
        const params = {type: directory.type};
        return this.$http.put(url, directory, {params}).then(({data}) => data);
    }

    deleteDirectory(companyId, directoryId, keepAccounts, type) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {keepAccounts, type};
        return this.$http.delete(url, {params}).then(({data}) => data);
    }

    getDirectoryGroups(companyId, directory) {
        const url = `app/rest/v2/company/${companyId}/directories/${directory.id}/groups`;
        const params = {type: directory.type};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    userVerification(companyId, directoryId, verificationtypes, verificationparameter, file) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const formData = new FormData();
        formData.append('file', file);
        const params = {type: 'userverification', verificationtypes, verificationparameter};
        const headers = {'Content-Type': undefined};
        return this.$http.post(url, formData, {params, headers}).then(({data}) => data);
    }

    resendVerifications(companyId, directory) {
        const url = `app/rest/v2/company/${companyId}/directories/${directory.id}`;
        const params = {type: 'resendverification', directoryType: directory.type};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getDirectoryConnectionDetails(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {type: 'details'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    updateActiveDirectoryActivationCode(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'updatecode'};
        return this.$http.put(url, null, {params}).then(({data}) => data);
    }

    updateOnPremisesConnectionSettings(companyId, directoryId, dto) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'setonpremconnection'};
        return this.$http.put(url, dto, {params}).then(({data}) => data);
    }

    deactivateActiveDirectoryAgent(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'deactivateagent'};
        return this.$http.put(url, null, {params}).then(({data}) => data);
    }

    getDomains(companyId, directoryId, type) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains`;
        const params = {type};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    createDomain(companyId, directoryId, domain) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains`;
        return this.$http.post(url, domain).then(({data}) => data);
    }

    editDomain(companyId, directoryId, domain) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains/${domain.id}`;
        return this.$http.put(url, domain).then(({data}) => data);
    }

    deleteDomain(companyId, directoryId, domainId, keepAccounts) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains/${domainId}`;
        const params = {keepAccounts};
        return this.$http.delete(url, {params}).then(({data}) => data);
    }

    updateAzureDomains(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/updatedomains`;
        return this.$http.put(url).then(({data}) => data);
    }

    getAzureTenantParameters(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/tenantparameters`;
        return this.$http.get(url).then(({data}) => data);
    }

    updateAzureTenantParameters(companyId, directoryId, tenantParameters) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/tenantparameters`;
        return this.$http.put(url, tenantParameters).then(({data}) => data);
    }

    testAzureConnection(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/connect`;
        return this.$http.get(url).then(({data}) => data);
    }

    azureSync(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/sync`;
        return this.$http.get(url).then(({data}) => data);
    }

    azureProvisioning(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/azuredirectory/${directoryId}/prov`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAzureStatus(companyId, directory) {
        const url = `app/rest/v2/company/${companyId}/directories/${directory.id}/status`;
        const params = {type: directory.type};
        return this.$http.get(url, {params}).then(({data}) => data);
    }
}

app.service('DirectoriesResource', DirectoriesResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directories-resource.service.js